import React from 'react';
import get from 'lodash/get';
import {
  HeadingText,
  BodyText,
  Accordion,
  AccordionRow,
} from '@paypalcorp/pp-react';
import getLocaleMessages from '../../../utils/localesMessages';

const { faq = {} } = getLocaleMessages('buttonsV3/login');

const Faq = () => {
  const getFaqContent = () => {
    const groups = get(faq, 'questions', {});
    return Object.keys(groups).map((key) => groups[key]);
  };

  return (
    <div className="login-faq-container">
      <HeadingText size="lg" className="login-faq-title">
        {faq.title}
      </HeadingText>
      <div className="faq-questions">
        <Accordion name="bf-login-faq">
          {getFaqContent().map((row, index) => (
            <AccordionRow
              isOpen="true"
              heading={
                <HeadingText size="sm" className="faq-heading-text">
                  {row.question}
                </HeadingText>
              }
              key={index}
            >
              <BodyText>
                <div
                  className="faq-row-content"
                  dangerouslySetInnerHTML={{ __html: row.answer }}
                />
              </BodyText>
            </AccordionRow>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default Faq;
